import { trackGtm } from './functions.js';

const sliceHTMLElements = element => {
	if (element) {
		element.innerHTML = element.textContent.replace(
			/([^]|\w)/g,
			"<span class='sliced-element tos-hide-before-animated'>$&</span>",
		);
	}
};

const gtmTracking = (
	eventAction,
	eventLabel,
	eventCategory = 'tools for science',
) => {
	trackGtm({
		eventCategory,
		eventAction,
		eventLabel,
	});
};

export { sliceHTMLElements, gtmTracking };
